import React from 'react';

interface PidShowRows {
  attributes: Array<any>;
  dataAttributeValueMap: Map<string, any>;
  RenderRow?: (attribute: any, dataAttributeValueMap: Map<string, any>, areaId?: number) => React.ReactNode;
}

const PidShowRows: React.FC<PidShowRows> = ({ attributes, dataAttributeValueMap, RenderRow }) => {
  return (
    <>
      {attributes.map((attribute, index) => {
        if (attribute.column_name === 'p_id') {
          return RenderRow ? RenderRow(attribute, dataAttributeValueMap) : null;
        }
        return null;
      })}
    </>
  );
};

export default PidShowRows;

